<template>
	<div class="modal fade show" tabindex="-1" role="dialog" style="display: block; background: rgba(0, 0, 0, 0.5);">
		<div class="modal-dialog modal-lg modal-fullscreen-sm-down" role="document">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white">
					<h5 class="modal-title">{{ title }}</h5>
					<button type="button" class="btn-close btn-close-white" @click="close()"></button>
				</div>

				<div class="modal-body">
					<p class="text-muted">Carica o sostituisci il PDF della fattura per la nota spesa <strong>{{ notaSpesa.DESCRIZIONE }}</strong>.</p>

					<div class="mx-auto d-flex flex-column align-items-center mb-3" style="max-width: 540px;">
						<label class="form-label">PDF Fattura</label>
						<Upload
							url="core/basic/upload"
							:args="{ modalita: 'THEB_uploadAllegatoSpesa', ID_NOTA_SPESA: notaSpesa.ID_NOTA_SPESA }"
							@onsuccess="onUploadSuccess"
							@onerror="onUploadError"
						/>
						<button v-if="hasFile" type="button" class="btn btn-danger btn-lg mt-2" @click="visualizzaPdf()">
							<i class="ph-file-pdf me-1"></i>Visualizza PDF
						</button>
					</div>

					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" @click="close()">Chiudi</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Upload from './utils/Upload.vue';

export default {
	name: 'ModalUploadPdfNotaSpesa',
	components: {
		Upload
	},
	props: {
		notaSpesa: {
			type: Object,
			required: true
		}
	},
	emits: ['close', 'saved'],
	computed: {
		hasFile() {
			return !!this.notaSpesa.FILE_ALLEGATO;
		},
		title() {
			return this.hasFile ? 'Sostituisci Fattura' : 'Carica Fattura';
		}
	},
	methods: {
		onUploadSuccess() {
			utils.alert.success('Fattura caricata');
			this.visualizzaPdf();
			this.$emit('saved');
			this.close();
		},
		onUploadError() {
			utils.alert.warning('Errore upload PDF');
		},
		visualizzaPdf() {
			utils.ajaxBlob('theb/note_spese/allegato', { ID_NOTA_SPESA: this.notaSpesa.ID_NOTA_SPESA }, (blob) => {
				const url = URL.createObjectURL(blob);
				window.open(url, '_blank');
			}, true, 'POST');
		},
		close() {
			this.$emit('close');
		}
	}
};
</script>

<style scoped>
.modal {
	z-index: 1050;
}

.modal.show {
	background-color: rgba(0, 0, 0, 0.5);
}

@media (max-width: 575.98px) {
	.modal-footer {
		flex-direction: column-reverse;
	}
	.modal-footer > * {
		width: 100%;
		margin-left: 0 !important;
		margin-right: 0 !important;
	}
}
</style>
